import * as actionTypes from "./actionTypes";
import { filterTypes, defaultFilters } from "../../constants";

export const reducerInitialState = {
  initializing: true,
  loading: false,
  queryParams: {},
  sortingParams: {},
  tasks: [],
  meta: {
    page: 1,
    perPage: 50,
    total: 0,
  },
  filters: {},
  error: null,
};

export default (state, action) => {
  switch (action.type) {
    case actionTypes.FETCH_TASKS_PENDING:
      return {
        ...state,
        ...action.payload,
        loading: true,
      };
    case actionTypes.FETCH_TASKS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    case actionTypes.FETCH_TASKS_SUCCEEDED:
      return {
        ...state,
        loading: false,
        ...action.payload,
      };
    case actionTypes.UPDATE_QUERY_PARAMS:
      return {
        ...state,
        queryParams: {
          ...state.queryParams,
          ...action.payload,
        },
      };
    case actionTypes.UPDATE_SORTING_PARAMS:
      return {
        ...state,
        queryParams: {
          ...state.queryParams,
          page: 1,
        },
        sortingParams: {
          ...action.payload,
        },
      };
    case actionTypes.INITIALIZE_FILTERS:
      return {
        ...state,
        initializing: false,
        filters: {
          ...state.filters,
          ...action.payload,
        },
      };
    case actionTypes.UPDATE_FILTERS:
      return {
        ...state,
        queryParams: {
          ...state.queryParams,
          page: 1,
        },
        filters: {
          ...state.filters,
          ...action.payload,
        },
      };
    case actionTypes.RESET_FILTERS:
      return {
        ...state,
        queryParams: {
          ...state.queryParams,
          page: 1,
        },
        filters: {
          ...defaultFilters,
          [filterTypes.CATEGORY]: state.filters[filterTypes.CATEGORY],
        },
      };
    default:
      return state;
  };
};
